import React, { Suspense, useEffect, useRef, useState } from "react";

import homePagePayload from "../../config/homePayload";
import homePageAPI from "../../api/homePageApi";

import CouponFlash from "./CouponFlash";
import { Link } from "react-router-dom";

import {
  Swiper,
  SwiperSlide,
  Autoplay,
  Navigation,
  Pagination,
} from "./Shared/CustomSwiper";
import { FaBox, FaCheckCircle, FaHeadset } from "react-icons/fa";

const OurProducts = React.lazy(() => import("./OurProducts"));
const TrendingProducts = React.lazy(() => import("./TrendingProducts"));
const BlogSection = React.lazy(() => import("./BlogSection"));
const Banner = React.lazy(() => import("./Banner"));
const Category = React.lazy(() => import("./Category"));
const Testimonials = React.lazy(() => import("./Testimonials"));
const Features = React.lazy(() => import("./Features"));
const CTABanner = React.lazy(() => import("./CTABanner"));
const CTABanner02 = React.lazy(() => import("./CTABanner02"));

function Home() {
  const [coupons, setCoupons] = useState([]);
  const [categories, setCategories] = useState([]);
  const [testimonials, setTestimonials] = useState([]);
  const [products, setProducts] = useState([]);
  const [topSellerProducts, setTopSellerProducts] = useState([]);
  const [blogs, setBlogs] = useState([]);
  const [topBanners, setTopBanners] = useState([]);
  const [middleBanners, setMiddleBanners] = useState([]);
  const firstMiddleBanner = middleBanners[0];
  const secondMiddleBanner = middleBanners[1];

  useEffect(() => {
    fetchHomePageDetails();
  }, []);

  const CACHE_TIME = 3 * 60 * 1000;

  const applyData = (data) => {
    setTopBanners(data?.banners?.filter((b) => b.position === "top"));
    setMiddleBanners(data?.banners?.filter((b) => b.position === "middle"));
    setCoupons(data?.coupons);
    setCategories(data?.categories);
    setTestimonials(data?.testimonials);
    setBlogs(data?.blogs);
    setProducts(data?.products);
    setTopSellerProducts(data?.topSellerProducts);
  };

  const fetchHomePageDetails = async () => {
    try {
      const cached = sessionStorage.getItem("homeData");
      const parsed = cached ? JSON.parse(cached) : null;

      if (parsed) applyData(parsed.data);

      if (!parsed || Date.now() - parsed.timestamp > CACHE_TIME) {
        const res = await homePageAPI.homePage(homePagePayload);
        if (res.code === 200) {
          sessionStorage.setItem(
            "homeData",
            JSON.stringify({ data: res.data, timestamp: Date.now() }),
          );
          if (!parsed) applyData(res.data); // only update state if no cache was shown
        }
      }
    } catch (error) {
      console.error("Home API Error:", error);
    }
  };

  return (
    <>
      {/* show banners */}
      {topBanners && topBanners.length > 0 && (
        <section className="hero-section" aria-label="Hero Banner">
          <Swiper
            modules={[Navigation, Pagination, Autoplay]}
            slidesPerView={1}
            pagination={{ clickable: true }}
            autoplay={{ delay: 30000 }}
            loop={true}
          >
            {topBanners.map((banner, index) => (
              <SwiperSlide key={index}>
                <Banner item={banner} />
              </SwiperSlide>
            ))}
          </Swiper>
        </section>
      )}
      {/* show categories */}
      {categories && categories.length > 0 && (
        <Category categories={categories} />
      )}

      {/* category cta section */}
      {firstMiddleBanner && (<CTABanner firstMiddleBanner={firstMiddleBanner} />)}

      {/* show products */}
      {products && products.length > 0 && (
        <OurProducts
          products={products}
          title="Our Products"
          eyebrow="Top Picks"
        />
      )}


      {/* category cta section */}
      {secondMiddleBanner && (<CTABanner02 secondMiddleBanner={secondMiddleBanner} />
      )}



      {/* show trending */}
      {topSellerProducts && topSellerProducts.length > 0 && (
        <TrendingProducts
          products={products}
          title="Trending Products"
          eyebrow="Top Picks"
        />
      )}
      {/* show testimonials */}
      {testimonials && testimonials.length > 0 && (
        <Testimonials testimonials={testimonials} />
      )}

      

      {/* show features */}
      <Features />
      {blogs && blogs.length > 0 && <BlogSection blogs={blogs} />}
    </>
  );
}

export default Home;
